"use client";

import {
  createContext,
  useContext,
  useState,
  ReactNode,
  useCallback,
} from "react";
import { GridRowId } from "@mui/x-data-grid-pro";

interface DeleteDialogContextType {
  campaignIdsToDelete: GridRowId[];
  closeDeleteDialog: () => void;
  deleteDialogOpen: boolean;
  openDeleteDialog: (campaignIds: GridRowId[]) => void;
}

const DeleteDialogContext = createContext<DeleteDialogContextType | undefined>(
  undefined,
);

export const useDeleteDialog = () => {
  const context = useContext(DeleteDialogContext);
  if (!context) {
    throw new Error("useDeleteDialog must be used within DeleteDialogProvider");
  }
  return context;
};

interface DeleteDialogProviderProps {
  children: ReactNode;
}

export function DeleteDialogProvider({ children }: DeleteDialogProviderProps) {
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [campaignIdsToDelete, setCampaignIdsToDelete] = useState<GridRowId[]>(
    [],
  );

  const openDeleteDialog = useCallback((campaignIds: GridRowId[]) => {
    setCampaignIdsToDelete(campaignIds);
    setDeleteDialogOpen(true);
  }, []);

  const closeDeleteDialog = useCallback(() => {
    setDeleteDialogOpen(false);
  }, []);

  return (
    <DeleteDialogContext.Provider
      value={{
        campaignIdsToDelete,
        closeDeleteDialog,
        deleteDialogOpen,
        openDeleteDialog,
      }}
    >
      {children}
    </DeleteDialogContext.Provider>
  );
}

